export default function NavigationBar() {
	return (
		<main>
			About what?
		</main>
	)
}